import { refreshToken, TOKENIZED_API } from '../../../../utils/api/index';
import { setBankInformation, setRoutingNumberError } from '../makePaymentAnonymousReducer';
import { getFundingInstruments } from '../../make-payment/step-two-amount/makePaymentStepTwoApi';

export const deleteFundingInstrument = (
  systemId,
  paymentOnFileId,
  notify,
  setFundingInstruments,
) => {
  return (dispatch) => {
    TOKENIZED_API.delete(`/billingAccounts/${systemId}/paymentSources/${paymentOnFileId}`)
      .then(() => {
        dispatch(getFundingInstruments(systemId, notify, null, setFundingInstruments));
      })
      .catch(() => {
        notify('Unable to delete the payment source', {
          variant: 'error',
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top',
          },
        });
      });
  };
};

export const verifyRoutingNumber = (routingNumber) => {
  refreshToken();
  return (dispatch) => {
    TOKENIZED_API.get(`/bankInformation/${routingNumber}`)
      .then((response) => {
        dispatch(setBankInformation(response.data));
        dispatch(setRoutingNumberError(''));
      })
      .catch(() => {
        dispatch(setRoutingNumberError('Routing number is not valid.'));
      });
  };
};
